module.exports = __webpack_public_path__ + "static/media/arn.50eb11e8.svg";